import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import { disponibiliteRavFaceNumeriqueGetter, disponibiliteFaceNumeriqueGetter } from '../catalogue/disponibiliteFaceNumeriqueGetter';

export default function decorateurRectanglePanneauxNumeriques(rectangle, facesArray,
  dateStart, dateEnd) {
  const dispoArray = facesArray.map(el => disponibiliteFaceNumeriqueGetter(el, dateStart, dateEnd));
  const niveauDispoPanneau = Math.max(...dispoArray);
  const rav = facesArray.map(el => disponibiliteRavFaceNumeriqueGetter(el, dateStart, dateEnd));
  rectangle.texte = rav.length > 0 ? rav[0].toString() : '0';
  switch (niveauDispoPanneau) {
    case niveauDispo.NON_DISPONIBLE:
      rectangle.stroke = niveauDispo.COULEUR_DISPO_INDISPONIBLE;
      rectangle.fill = niveauDispo.COULEUR_DISPO_INDISPONIBLE;
      break;
    case niveauDispo.PARTIELLEMENT_DISPONIBLE:
      rectangle.stroke = niveauDispo.COULEUR_DISPO_PARTIELLEMENT;
      rectangle.fill = niveauDispo.COULEUR_DISPO_PARTIELLEMENT;
      break;
    case niveauDispo.DISPONIBLE:
      rectangle.stroke = niveauDispo.COULEUR_DISPO_DISPONIBLE;
      rectangle.fill = niveauDispo.COULEUR_BLANCHE;
      break;
    case niveauDispo.DISPONIBILITE_INDEFINI:
    default:
      rectangle.stroke = niveauDispo.COULEUR_BLANCHE;
      rectangle.fill = niveauDispo.COULEUR_BLANCHE;
      break;
  }
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurRectanglePanneauxNumeriques.js